import LinkUser from './pages/LinkUser.vue'

const router = {
  name: 'LinkUser',
  path: '/link-user',
  component: LinkUser,
  meta: {
    titleHeader: 'LinkUser'
  }
}

export default router
